import { GridCellProps } from '@progress/kendo-react-grid';
import GridCellBase from 'src/components/GridCellBase';
import useRedirect from 'src/hooks/useRedirect';

const ReceiptDetailsCell = (props: GridCellProps) => {
  let field = props.field || '';
  let value = props.dataItem[field];
  const { getUrl, redirect } = useRedirect();
  let id = props.dataItem.receivingReceiptId;
  return (
    <GridCellBase {...props} title={value} rowSelectionEnabled={true}>
      <button
        onClick={() => {
          redirect(getUrl('receiptDetails')(id, props.dataItem.poId));
        }}
        className="text-link cursor-pointer underline"
      >
        {value}
      </button>
    </GridCellBase>
  );
};
export default ReceiptDetailsCell;
